import * as Yup from 'yup';
import { FormikErrors, FormikTouched } from 'formik';
import { Step as StepProps } from '@service-victoria/component-library/components/Wizard/props';
import * as Interfaces from 'interfaces';
import { constants } from 'utils';
import { Step as Review } from '../Review';
import { Step as Identity } from '../Identity';
import Component from './VisitVictoria';

type Values = Partial<Interfaces.Common.FormValues> & {
  consent?: boolean;
};

const initialValues: Values = {};
const initialErrors: FormikErrors<Values> = {};
const initialTouched: FormikTouched<Values> = {};

const wizardSchema = Yup.object().shape<Values>({
  consent: Yup.mixed().notRequired()
});

const validationSchema = wizardSchema;

const Step: StepProps<Values> = {
  id: 'consent-and-declaration',
  title: constants.Page.title,
  stepName: 'Consent & Declaration',
  validation: {
    schema: validationSchema,
    fieldNames: []
  },
  Component,
  navigation: {
    normal: [
      {
        content: 'Back',
        type: 'secondary',
        shouldValidate: false,
        onClick: (wizardContext, form, appStates) => {
          const appContext = appStates[constants.StorageKeys.State] as Interfaces.Store.AppContext;
          appContext.actions.updateError();
          wizardContext.dispatch({
            type: 'GOTO_STEP',
            stepId: Identity.id,
            values: form.values
          });
        }
      },
      {
        content: 'I agree',
        shouldValidate: true,
        type: 'primary',
        onClick: (context, form) => {
          context.dispatch({
            type: 'GOTO_STEP',
            stepId: Review.id,
            values: form.values
          });
        }
      }
    ]
  }
};

export { Step, wizardSchema, initialErrors, initialTouched, initialValues };
